import styled from "styled-components";

export const Card = styled.section`
  background: white;
  border-radius: 0.8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  min-width: 18.5rem;
  margin-right: 1.5rem;
  img {
    padding-right: 1rem;
  }
  span {
    font-size: 1.6rem;
  }
`;

export const CabsFeatureOuterWrap = styled.div`
  position: relative;
  margin-top: 1.5rem;
  margin-right: 1rem;
`;
export const CabFeatureWrap = styled.div(
(props) => `
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  margin-left: ${props.left ? "2.5rem" : ""};
  &::-webkit-scrollbar {
    display: none;
  }
`
);

export const SliderArrowRight = styled.button(
  (props) => `
        width: 4rem;
        height: 4rem;
        display: flex;
        border-radius: 50%;
        background-color: white;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: -1.5rem;
        transform: translateY(-50%);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
        border:none;
        outline: 0;
      `
);

export const SliderArrow = styled.button(
  (props) => `
        width: 4rem;
        height: 4rem;
        display: flex;
        border-radius: 50%;
        background-color: white;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: absolute;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
        border:none;
        outline: 0;
        &.right {
          top: 50%;
          right: -1rem;
          transform: translateY(-50%);
        }
        &.left {
          top: 50%;
          left: -1rem;
          transform: translateY(-50%);
        }
      `
);
